import { useState } from 'react';
import { Input } from '@/components/ui/input';
import {
  WEEKDAYS,
  WEEKDAY_LABELS,
  type MinNightsParams,
  type RuleFormProps,
  intStrOpt,
} from '@/lib/pricingRules';

// min_nights: a min-stay FLOOR by arrival weekday. `by_dow` maps weekday key
// ("mon".."sun") to a min-nights integer (>=1). Local string-draft state per
// weekday, seeded once from params; blanks are omitted from the emitted
// `by_dow` (the backend requires it non-empty, but the parent surfaces that
// 400 — we just don't force a value into every row here).

function paramsToDrafts(params: MinNightsParams): Record<string, string> {
  const drafts: Record<string, string> = {};
  for (const day of WEEKDAYS) {
    const v = params.by_dow?.[day];
    drafts[day] = v != null ? String(v) : '';
  }
  return drafts;
}

function draftsToParams(drafts: Record<string, string>): MinNightsParams {
  const by_dow: Record<string, number> = {};
  for (const day of WEEKDAYS) {
    const n = intStrOpt(drafts[day] ?? '');
    if (typeof n === 'number') by_dow[day] = n;
  }
  return { by_dow };
}

export function MinNightsRuleForm({ params, onChange }: RuleFormProps<MinNightsParams>) {
  const [drafts, setDrafts] = useState<Record<string, string>>(() => paramsToDrafts(params));

  function patch(day: string, value: string) {
    const next = { ...drafts, [day]: value };
    setDrafts(next);
    onChange(draftsToParams(next));
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {WEEKDAYS.map((day) => (
        <Input
          key={day}
          label={WEEKDAY_LABELS[day]}
          type="number"
          min={1}
          step={1}
          value={drafts[day]}
          onChange={(e) => patch(day, e.target.value)}
          placeholder="min nights"
        />
      ))}
    </div>
  );
}
